import SmartAlertTemplate from '@/components/SmartAlertTemplate';
import { smartAlertPageMap } from '@/data/smartAlertPages';

const page = smartAlertPageMap['drugs-and-alcohol'];

if (!page) {
  throw new Error('Smart alert data missing for drugs & alcohol');
}

const SmartAlertDrugsAlcohol = () => {
  return <SmartAlertTemplate page={page} />;
};

export default SmartAlertDrugsAlcohol;


